import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared.module';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PrivateLayoutComponent } from './private-layout/private-layout.component';
import { PanelLayoutComponent } from './panel-layout/panel-layout.component';
import { UpdateFirstPasswordComponent } from '../components/ui/update-first-password/update-first-password.component';
import { ComponentsModule } from '../components/components.module';

@NgModule({
  declarations: [
    PrivateLayoutComponent,
    PanelLayoutComponent,
    UpdateFirstPasswordComponent,
  ],
  imports: [
    SharedModule,
    RouterModule,
    MatChipsModule,
    MatIconModule,
    MatMenuModule,
    ComponentsModule,
    MatRippleModule,
    MatTooltipModule,
  ],
})
export class LayoutsModule {}
